import React, { useMemo, useState } from 'react';

import { Button } from '~/ui/components';
import { Compare } from '~/ui/components/Compare/Compare';
import { Flex, NoImageContainer } from './Image.styled';

type ImageProps = {
  files: any;
};

export function Image({ files }: ImageProps) {
  const [isFront, setIsFront] = useState(true);

  const imageUrl = useMemo(() => {
    let image;

    const DOCUMENTFRONTRG = files?.find(
      (file) => file?.type === 'DOCUMENTFRONT' || file?.personImageType === 'DOCUMENT_FRONT',
    );

    const DOCUMENTBACKRG = files?.find(
      (file) => file?.type === 'DOCUMENTBACK' || file?.personImageType === 'DOCUMENT_BACK',
    );

    const CNH_DIGITAL = files?.find(
      (file) => file?.type === 'DOCUMENTFRONT' && file?.documentType === 'CNH_DIGITAL' && !file.inactive,
    );

    if (CNH_DIGITAL && CNH_DIGITAL.extension === '.pdf') {
      return `pdf:${CNH_DIGITAL.url || CNH_DIGITAL.imageUrl}`;
    }

    if (DOCUMENTFRONTRG) {
      image = isFront ? DOCUMENTFRONTRG : DOCUMENTBACKRG;
    }

    return image?.url || image?.imageUrl;
  }, [files, isFront]);

  const isPdf = useMemo(() => imageUrl?.startsWith('pdf:'), [imageUrl]);

  return (
    <Flex id="image">
      {imageUrl ? (
        <Compare images={[imageUrl]} initialZoom={1} />
      ) : (
        <NoImageContainer>Nenhuma imagem disponível</NoImageContainer>
      )}

      {!isPdf && imageUrl && (
        <Button onClick={() => setIsFront(!isFront)} rounded variant="outline" size="sm">
          {isFront ? 'Ver verso' : 'Ver frente'}
        </Button>
      )}
    </Flex>
  );
}
